export default {
  connected: false,
  error: '',
};
